'use client';
import React from 'react';
import LikeBox from '@modules/like-box';
import { PostLikeProps } from './post-like.props';
import postLikeApi from '@api/posts/post-like';
import postDislikeApi from '@api/posts/post-dislike';
import { AlertActions } from '@store/alert/alert-action';
import { useDispatch } from 'react-redux';

const PostLike = ({ id, like, dislike }: PostLikeProps) => {
  const dispatch = useDispatch();

  const handleLike = async () => {
    try {
      const res = await postLikeApi({ id });
      dispatch(AlertActions.showAlert({ text: res?.message || 'شما با موفقیت لایک کردید.', severity: 'success' }));
    } catch (error: any) {
      dispatch(AlertActions.showAlert({ text: error?.message || 'کد وارد شده صحیح نمی باشد.', severity: 'danger' }));
    }
  };

  const handleDislike = async () => {
    try {
      const res = await postDislikeApi({ id });
      dispatch(AlertActions.showAlert({ text: res?.message || 'شما با موفقیت لایک کردید.', severity: 'success' }));
    } catch (error: any) {
      dispatch(AlertActions.showAlert({ text: error?.message || 'کد وارد شده صحیح نمی باشد.', severity: 'danger' }));
    }
  };

  return (
    <LikeBox
      like={like}
      dislike={dislike}
      handleLike={handleLike}
      handleDislike={handleDislike}
    />
  );
};

export default PostLike;
